// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1ZDh9","rootCenter":"LoadMoreObserver_rootCenter____GaD","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__XcBjQ"};